import {
  CreateDocumentInput,
  DocumentTypeEnum,
} from '@/shared/types/types.generated';

export const getFileKey = (file: File, index: number): string =>
  `${file.name}-${file.size}-${file.lastModified}-${index}`;

export const getBaseDocumentInputFromFile = (
  file: File,
  name?: string,
): CreateDocumentInput => {
  const fileExtension = file.name?.split('.')?.pop()?.toUpperCase();

  let documentType: DocumentTypeEnum;
  if (
    fileExtension &&
    Object.values(DocumentTypeEnum).includes(fileExtension as DocumentTypeEnum)
  ) {
    documentType = fileExtension as DocumentTypeEnum;
  } else {
    documentType = DocumentTypeEnum.Others;
  }

  return {
    fileName: file.name,
    name: name?.trim() || file.name,
    documentType,
  };
};
